import throttle from 'lodash/throttle';
import newStore from './store';
import { saveState } from './sessionStorage';

const store = newStore();

/*
    handleThrottle checks whether the state change was to the sessionExpiryTime.
    If so it immediately saves it to sessionStorage, otherwise it throttles the save for 1 second.
    This prevents potential issue of browser refresh losing new sessionExpiryTime before it is saved.
*/

export const throttled = throttle(() => {
  saveState(store.getState());
}, 1000);

let currentExpiryTime;
const handleThrottle = () => {
  const previousExpiryTime = currentExpiryTime;
  currentExpiryTime = store.getState().consultationReducer.sessionExpiryTime;
  if (previousExpiryTime !== currentExpiryTime || store.getState().flagsReducer.showSessionExpiryValidationOnLoad) {
    return throttled.flush();
  }
  return throttled();
};

store.subscribe(handleThrottle);

export { store };
